import {
  resolveCanvasFontStyle,
  resolveFontFamilyForCanvas,
} from './normalizeAnnotationFontStylesForLoad';

/**
 * Ensure custom @font-face families used by text annotations are loaded before
 * Konva measures/draws Text nodes (otherwise text can be invisible until a redraw).
 */
const buildFontShorthands = (annotation) => {
  const storedFamily = annotation?.fontFamily;
  if (!storedFamily || !annotation?.text) {
    return [];
  }

  const family = resolveFontFamilyForCanvas(storedFamily);
  const fontStyle = resolveCanvasFontStyle(storedFamily, annotation.fontStyle);
  const styleTokens = String(fontStyle)
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);
  const cssStyle = styleTokens.includes('italic') ? 'italic' : 'normal';
  const cssWeight = styleTokens.includes('bold') ? '700' : '400';
  const fontSize = Math.max(1, Math.round(Number(annotation.fontSize) || 16));
  const quotedFamily = `"${family}"`;

  return [`${cssStyle} ${cssWeight} ${fontSize}px ${quotedFamily}`];
};

const preloadAnnotationFonts = (annotations = {}) => {
  if (typeof document === 'undefined' || !document.fonts?.load) {
    return Promise.resolve();
  }

  const fontShorthands = new Set();
  Object.values(annotations).forEach((annotation) => {
    buildFontShorthands(annotation).forEach((font) => fontShorthands.add(font));
  });

  if (fontShorthands.size === 0) {
    return Promise.resolve();
  }

  return Promise.all(
    [...fontShorthands].map((font) =>
      document.fonts.load(font).catch(() => undefined),
    ),
  ).then(() => document.fonts.ready.catch(() => undefined));
};

export default preloadAnnotationFonts;
